module.exports = __webpack_public_path__ + "img/plan_tratamiento_integral.d172054a.png";